import React from 'react';
import { object, bool, string } from 'prop-types';
import Redirect from './Redirect';
import dataAids from '../../common/dataAids';
import olaStatuses from '../../ola/constants/olaStatus';
import olsStatuses from '../../ols/constants/olsStatuses';
import olsAccountStatuses from '../../ols/constants/olsAccountStatus';

export default class AuthRedirectBootstrap extends React.Component {
  render() {
    const {
      featureFlags,
      hasShopWidget,
      hasAppointmentsWidget,
      olaStatus,
      olsStatus,
      olsAccountStatus
    } = this.props;
    const hasOls =
      featureFlags.isOLSContactsOn &&
      hasShopWidget &&
      olsAccountStatus === olsAccountStatuses.active &&
      olsStatus === olsStatuses.PROVISION_SUCCESS;
    const hasOla = hasAppointmentsWidget && olaStatus === olaStatuses.provisionSuccess;

    return (
      <Redirect
        { ...this.props }
        data-aid={ dataAids.AUTH_REDIRECT }
        hasOls={ hasOls }
        hasOla={ hasOla }
        goPay={ featureFlags.isGoPayContactsOn }
      />
    );
  }
}

AuthRedirectBootstrap.propTypes = {
  staticContent: object.isRequired,
  featureFlags: object.isRequired,
  hasShopWidget: bool.isRequired,
  olaStatus: string.isRequired,
  hasAppointmentsWidget: bool.isRequired,
  olsStatus: string.isRequired,
  olsAccountStatus: string.isRequired
};
